import React, { forwardRef } from "react";
import Markdown from "react-markdown";
import { BaseText, BaseTextProps } from "web/react/emo/shared/components/base-text";
import { ResponsiveTextStyle } from "web/react/emo/sprinkles.css";
import * as styles from "./rich-text.css";

export interface RichTextProps extends BaseTextProps {
    textStyle: ResponsiveTextStyle;
    as?: "p" | "span" | "div";
    markdownProps?: any;
    children: string;
}

const RichText = forwardRef(
    (
        { textStyle, as = "div", children, markdownProps, ...textProps }: RichTextProps,
        ref
    ): JSX.Element => {
        const components = {
            p(props: any) {
                return <p className={styles.paragraph} {...props} />;
            },
        };

        return (
            <BaseText ref={ref} textStyle={textStyle} as={as} {...textProps}>
                <Markdown components={components} {...markdownProps}>
                    {children}
                </Markdown>
            </BaseText>
        );
    }
);

RichText.displayName = "RichText";
export { RichText };
